import { render, staticRenderFns } from "./SARSQuestion.vue?vue&type=template&id=19725a55&"
import script from "./SARSQuestion.vue?vue&type=script&lang=js&"
export * from "./SARSQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports